import { Controller } from '@hotwired/stimulus';
import {Modal} from "bootstrap";
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        chatId: String,
    };

    initialize() {
        this.modal = new Modal(this.element, {
            backdrop: 'static',
            focus: false,
            show: false,
        });

        this.modal.show();

        const url = routes['app_messages_markcalled'].replace('__id__', this.chatIdValue);

        $.post(url, {}, function () {
        }).fail(function () {
        });

        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Account",
                "action": "View Phone number",
                "label": GA_EVENT_LABEL,
            },
        });
    }
}
